const normalized = value => String(value || '').normalize('NFKD').replace(/\p{M}/gu, '').trim().toLocaleLowerCase('en');
const alphabetical = (a, b) => a.name.localeCompare(b.name, 'en', { sensitivity: 'base' }) || a.accountNo.localeCompare(b.accountNo);

export function searchCustomers(customers, query, includePending = false) {
  const term = normalized(query);
  const firstLetter = /^\p{L}$/u.test(term);
  const matches = (customers || []).filter(customer => (includePending || !customer.deletionPending) && (
    !term || normalized(customer.name).startsWith(term) || (!firstLetter && (
      normalized(customer.accountNo).includes(term) || normalized(customer.phone).includes(term)))));
  return matches.sort((a, b) => (term ? (b.transactionCount || 0) - (a.transactionCount || 0) : 0) || alphabetical(a, b));
}